export const slugsPart2 = {
    "C": "c",
    "C++": "cplusplus",
    "C++ Builder": "cplusplusbuilder",
    "Cachet": "cachet",
    "Caddy": "caddy",
    "Cadillac": "cadillac",
    "CafePress": "cafepress",
    "Cairo Graphics": "cairographics",
    "Cairo Metro": "cairometro",
    "CaixaBank": "caixabank",
    "CakePHP": "cakephp",
    "Cal.com": "caldotcom",
    "Calendly": "calendly",
    "Calibre-Web": "calibreweb",
    "Campaign Monitor": "campaignmonitor",
    "Camunda": "camunda",
    "Canonical": "canonical",
    "Canvas": "canvas",
    "Capacitor": "capacitor",
    "CapRover": "caprover",
    "Car Throttle": "carthrottle",
    "Cardano": "cardano",
    "Cardmarket": "cardmarket",
    "Carlsberg Group": "carlsberggroup",
    "Carrd": "carrd",
    "Carrefour": "carrefour",
    "Carto": "carto",
    "Cash App": "cashapp",
    "Castbox": "castbox",
    "Castorama": "castorama",
    "Castro": "castro",
    "Caterpillar": "caterpillar",
    "CBC": "cbc",
    "CBS": "cbs",
    "CCC": "ccc",
    "CCleaner": "ccleaner",
    "CD Projekt": "cdprojekt",
    "CE": "ce",
    "Celery": "celery",
    "Celestron": "celestron",
    "CentOS": "centos",
    "Ceph": "ceph",
    "Cesium": "cesium",
    "Chai": "chai",
    "Chainguard": "chainguard",
    "Chainlink": "chainlink",
    "Chakra UI": "chakraui",
    "Change Detection": "changedetection",
    "Channel 4": "channel4",
    "Charles": "charles",
    "Chart.js": "chartdotjs",
    "ChartMogul": "chartmogul",
    "Chase": "chase",
    "ChatBot": "chatbot",
    "Chatwoot": "chatwoot",
    "CheckiO": "checkio",
    "Checkmarx": "checkmarx",
    "Checkmk": "checkmk",
    "Chedraui": "chedraui",
    "Cheerio": "cheerio",
    "Chef": "chef",
    "Chemex": "chemex",
    "Chess.com": "chessdotcom",
    "Chevrolet": "chevrolet",
    "Chia Network": "chianetwork",
    "China Eastern Airlines": "chinaeasternairlines",
    "China Southern Airlines": "chinasouthernairlines",
    "Chocolatey": "chocolatey",
    "Chromatic": "chromatic",
    "Chrome Web Store": "chromewebstore",
    "Chrysler": "chrysler",
    "Chupa Chups": "chupachups",
    "Cilium": "cilium",
    "Cinema 4D": "cinema4d",
    "Cinnamon": "cinnamon",
    "Circle": "circle",
    "CircleCI": "circleci",
    "CircuitVerse": "circuitverse",
    "Cirrus CI": "cirrusci",
    "Cisco": "cisco",
    "Citrix": "citrix",
    "Citroën": "citroen",
    "CiviCRM": "civicrm",
    "Civo": "civo",
    "Clarifai": "clarifai",
    "Claris": "claris",
    "Clarivate": "clarivate",
    "Claude": "claude",
    "Clerk": "clerk",
    "Clever Cloud": "clevercloud",
    "ClickHouse": "clickhouse",
    "ClickUp": "clickup",
    "CLion": "clion",
    "Clockify": "clockify",
    "Clojure": "clojure",
    "Cloud 66": "cloud66",
    "Cloud Foundry": "cloudfoundry",
    "Cloud Native Build": "cloudnativebuild",
    "CloudBees": "cloudbees",
    "CloudCannon": "cloudcannon",
    "Cloudera": "cloudera",
    "Cloudflare": "cloudflare",
    "Cloudflare Pages": "cloudflarepages",
    "Cloudflare Workers": "cloudflareworkers",
    "Cloudinary": "cloudinary",
    "Cloudron": "cloudron",
    "Cloudsmith": "cloudsmith",
    "Cloudways": "cloudways",
    "Clubforce": "clubforce",
    "Clubhouse": "clubhouse",
    "Clyp": "clyp",
    "CMake": "cmake",
    "CNCF": "cncf",
    "CNES": "cnes",
    "CNET": "cnet",
    "CNN": "cnn",
    "Co-op": "coop",
    "cobalt": "cobalt",
    "Coca-Cola": "cocacola",
    "Cockpit": "cockpit",
    "Cockroach Labs": "cockroachlabs",
    "CocoaPods": "cocoapods",
    "Cocos": "cocos",
    "Coda": "coda",
    "Codacy": "codacy",
    "Code Climate": "codeclimate",
    "Code::Blocks": "codeblocks",
    "Codeberg": "codeberg",
    "Codecademy": "codecademy",
    "CodeceptJS": "codeceptjs",
    "CodeChef": "codechef",
    "Codecov": "codecov",
    "CodeCrafters": "codecrafters",
    "CodeFactor": "codefactor",
    "Codeforces": "codeforces",
    "Codefresh": "codefresh",
    "CodeIgniter": "codeigniter",
    "Codemagic": "codemagic",
    "Codementor": "codementor",
    "CodeMirror": "codemirror",
    "CodeNewbie": "codenewbie",
    "CodeProject": "codeproject",
    "Coder": "coder",
    "CodeRabbit": "coderabbit",
    "CodersRank": "codersrank",
    "Coderwall": "coderwall",
    "CodeSandbox": "codesandbox",
    "Codeship": "codeship",
    "CodeSignal": "codesignal",
    "CodeStream": "codestream",
    "Codewars": "codewars",
    "Coding Ninjas": "codingninjas",
    "CodinGame": "codingame",
    "Codio": "codio",
    "CoffeeScript": "coffeescript",
    "Coggle": "coggle",
    "Coinbase": "coinbase",
    "CoinMarketCap": "coinmarketcap",
    "Collabora Online": "collaboraonline",
    "ComicFury": "comicfury",
    "comma": "comma",
    "Commerzbank": "commerzbank",
    "commitlint": "commitlint",
    "Commodore": "commodore",
    "Common Lisp": "commonlisp",
    "Common Workflow Language": "commonworkflowlanguage",
    "Compiler Explorer": "compilerexplorer",
    "Composer": "composer",
    "CompTIA": "comptia",
    "Comsol": "comsol",
    "Conan": "conan",
    "Concourse": "concourse",
    "Conda-Forge": "condaforge",
    "Conekta": "conekta",
    "Confluence": "confluence",
    "Construct 3": "construct3",
    "Consul": "consul",
    "Contabo": "contabo",
    "Contactless Payment": "contactlesspayment",
    "containerd": "containerd",
    "Contao": "contao",
    "Contentful": "contentful",
    "Contentstack": "contentstack",
    "Continente": "continente",
    "Contributor Covenant": "contributorcovenant",
    "Conventional Commits": "conventionalcommits",
    "Convertio": "convertio",
    "Cookiecutter": "cookiecutter",
    "Cooler Master": "coolermaster",
    "Coolify": "coolify",
    "Copa Airlines": "copaairlines",
    "Coppel": "coppel",
    "Cora": "cora",
    "CorelDRAW": "coreldraw",
    "Corona Engine": "coronaengine",
    "Corona Renderer": "coronarenderer",
    "Corsair": "corsair",
    "Couchbase": "couchbase",
    "Counter-Strike": "counterstrike",
    "CountingWorks PRO": "countingworkspro",
    "Coursera": "coursera",
    "Coveralls": "coveralls",
    "Coze": "coze",
    "cPanel": "cpanel",
    "Craft CMS": "craftcms",
    "Craftsman": "craftsman",
    "CrateDB": "cratedb",
    "Crayon": "crayon",
    "Creality": "creality",
    "Create React App": "createreactapp",
    "Creative Commons": "creativecommons",
    "Creative Technology": "creativetechnology",
    "Credly": "credly",
    "Crehana": "crehana",
    "Crew United": "crewunited",
    "CrewAI": "crewai",
    "Critical Role": "criticalrole",
    "Crowdin": "crowdin",
    "Crowdsource": "crowdsource",
    "Crunchbase": "crunchbase",
    "Crunchyroll": "crunchyroll",
    "CRYENGINE": "cryengine",
    "Cryptomator": "cryptomator",
    "CryptPad": "cryptpad",
    "Crystal": "crystal",
    "CSDN": "csdn",
    "CSS": "css",
    "CSS Design Awards": "cssdesignawards",
    "CSS Modules": "cssmodules",
    "CSS Wizardry": "csswizardry",
    "CTS": "cts",
    "Cucumber": "cucumber",
    "Cultura": "cultura",
    "curl": "curl",
    "CurseForge": "curseforge",
    "Cursor": "cursor",
    "Custom Ink": "customink",
    "CyberDefenders": "cyberdefenders",
    "Cycling '74": "cycling74",
    "Cypress": "cypress",
    "Cytoscape.js": "cytoscapedotjs",
    "D": "d",
    "D-EDGE": "dedge",
    "D-Wave Systems": "dwavesystems",
    "D3": "d3",
    "Dacia": "dacia",
    "DAF": "daf",
    "daily.dev": "dailydotdev",
    "Dailymotion": "dailymotion",
    "daisyUI": "daisyui",
    "Dapr": "dapr",
    "Dark Reader": "darkreader",
    "Dart": "dart",
    "Darty": "darty",
    "Das Erste": "daserste",
    "Dash": "dash",
    "Dash0": "dash0",
    "Dashlane": "dashlane",
    "Dask": "dask",
    "Dassault Systèmes": "dassaultsystemes",
    "data.ai": "datadotai",
    "Databricks": "databricks",
    "DataCamp": "datacamp",
    "Datadog": "datadog",
    "DataGrip": "datagrip",
    "Dataiku": "dataiku",
    "DataStax": "datastax",
    "date-fns": "datefns",
    "DATEV": "datev",
    "DatoCMS": "datocms",
    "Datto": "datto",
    "DaVinci Resolve": "davinciresolve",
    "Dazhong Dianping": "dazhongdianping",
    "DAZN": "dazn",
    "DBeaver": "dbeaver",
    "dblp": "dblp",
    "DC Entertainment": "dcentertainment",
    "De'Longhi": "delonghi",
    "Debian": "debian",
    "Debrid-Link": "debridlink",
    "Decap CMS": "decapcms",
    "Decentraland": "decentraland",
    "DeepCool": "deepcool",
    "Deepgram": "deepgram",
    "deepin": "deepin",
    "DeepL": "deepl",
    "DeepMind": "deepmind",
    "Deepnote": "deepnote",
    "Deliveroo": "deliveroo",
    "Dell": "dell",
    "Delphi": "delphi",
    "Delta": "delta",
    "Deluge": "deluge",
    "Deno": "deno",
    "Denon": "denon",
    "Dependabot": "dependabot",
    "Depositphotos": "depositphotos",
    "Der Spiegel": "derspiegel",
    "Deutsche Bahn": "deutschebahn",
    "Deutsche Bank": "deutschebank",
    "Deutsche Post": "deutschepost",
    "Deutsche Telekom": "deutschetelekom",
    "Deutsche Welle": "deutschewelle",
    "dev.to": "devdotto",
    "Devbox": "devbox",
    "DevExpress": "devexpress",
    "DeviantArt": "deviantart",
    "Devpost": "devpost",
    "devRant": "devrant",
    "Dgraph": "dgraph",
    "DHL": "dhl",
    "diagrams.net": "diagramsdotnet",
    "Dialogflow": "dialogflow",
    "Diaspora": "diaspora",
    "Dictionary.com": "dictionarydotcom",
    "Digg": "digg",
    "Digi-Key Electronics": "digikeyelectronics",
    "DigitalOcean": "digitalocean",
    "Diners Club": "dinersclub",
    "Dior": "dior",
    "Directus": "directus",
    "Discogs": "discogs",
    "Discord": "discord",
    "discord.js": "discorddotjs",
    "Discourse": "discourse",
    "Discover": "discover",
    "Disqus": "disqus",
    "Disroot": "disroot",
    "Distrobox": "distrobox",
    "Distrokid": "distrokid",
    "Django": "django",
    "DJI": "dji",
    "Dlib": "dlib",
    "DLNA": "dlna",
    "dm": "dm",
    "DMM": "dmm",
    "Docker": "docker",
    "Docs.rs": "docsdotrs",
    "Docsify": "docsify",
    "Doctrine": "doctrine",
    "Docusaurus": "docusaurus",
    "Dodo Payments": "dodopayments",
    "Dogecoin": "dogecoin",
    "DOI": "doi",
    "Dolby": "dolby",
    "Dolibarr": "dolibarr",
    "Dolphin": "dolphin",
    "DoorDash": "doordash",
    "Dota 2": "dota2",
    "Douban": "douban",
    "Douban Read": "doubanread",
    "Dovecot": "dovecot",
    "Dovetail": "dovetail",
    "Downdetector": "downdetector",
    "Doxygen": "doxygen",
    "DPD": "dpd",
    "Dragonframe": "dragonframe",
    "Draugiem.lv": "draugiemdotlv",
    "Dreamstime": "dreamstime",
    "Dribbble": "dribbble",
    "Drizzle": "drizzle",
    "Drone": "drone",
    "Drooble": "drooble",
    "Dropbox": "dropbox",
    "Drupal": "drupal",
    "DS Automobiles": "dsautomobiles",
    "DTS": "dts",
    "DTube": "dtube",
    "Ducati": "ducati",
    "DuckDB": "duckdb",
    "DuckDuckGo": "duckduckgo",
    "Dungeons & Dragons": "dungeonsanddragons",
    "Dunked": "dunked",
    "Dunzo": "dunzo",
    "Duolingo": "duolingo",
    "Duplicati": "duplicati",
    "DVC": "dvc",
    "dwm": "dwm",
    "Dynatrace": "dynatrace",
    "E.Leclerc": "edotleclerc",
    "E3": "e3",
    "EA": "ea",
    "EAC": "eac",
    "Eagle": "eagle",
    "EasyEDA": "easyeda",
    "easyJet": "easyjet",
    "eBay": "ebay",
    "EBOX": "ebox",
    "Eclipse Adoptium": "eclipseadoptium",
    "Eclipse Che": "eclipseche",
    "Eclipse IDE": "eclipseide",
    "Eclipse Jetty": "eclipsejetty",
    "Eclipse Mosquitto": "eclipsemosquitto",
    "Eclipse Vert.x": "eclipsevertdotx",
    "Ecosia": "ecosia",
    "Ecovacs": "ecovacs",
    "EDEKA": "edeka",
    "Edge Impulse": "edgeimpulse",
    "EditorConfig": "editorconfig",
    "Educative": "educative",
    "edX": "edx",
    "Effect": "effect",
    "egghead": "egghead",
    "Egnyte": "egnyte",
    "Eight": "eight",
    "Eight Sleep": "eightsleep",
    "EJS": "ejs",
    "Elastic": "elastic",
    "Elastic Cloud": "elasticcloud",
    "Elastic Stack": "elasticstack",
    "Elasticsearch": "elasticsearch",
    "Elavon": "elavon",
    "Electron": "electron",
    "Electron Fiddle": "electronfiddle",
    "electron-builder": "electronbuilder",
    "Elegoo": "elegoo",
    "Element": "element",
    "elementary": "elementary",
    "Elementor": "elementor",
    "ElevenLabs": "elevenlabs",
    "Eleventy": "eleventy",
    "Elgato": "elgato",
    "Elixir": "elixir",
    "Elk": "elk",
    "Elm": "elm",
    "Elsevier": "elsevier",
    "Embarcadero": "embarcadero",
    "Embark": "embark",
    "Ember.js": "emberdotjs",
    "Emby": "emby",
    "Emirates": "emirates",
    "Emlakjet": "emlakjet",
    "EndeavourOS": "endeavouros",
    "Enpass": "enpass",
    "ENS": "ens",
    "Ente": "ente",
    "EnterpriseDB": "enterprisedb",
    "Envato": "envato",
    "Envoy Proxy": "envoyproxy",
    "EPEL": "epel",
    "Epic Games": "epicgames",
    "Epson": "epson",
    "Equinix Metal": "equinixmetal",
    "Eraser": "eraser",
    "Ericsson": "ericsson",
    "Erlang": "erlang",
    "ERPNext": "erpnext",
    "esbuild": "esbuild",
    "ESEA": "esea",
    "ESLGaming": "eslgaming",
    "ESLint": "eslint",
    "Esoteric Software": "esotericsoftware",
    "ESPHome": "esphome",
    "Espressif": "espressif",
    "ESRI": "esri",
    "etcd": "etcd",
    "Ethereum": "ethereum",
    "Ethers": "ethers",
    "Ethiopian Airlines": "ethiopianairlines",
    "Etihad Airways": "etihadairways",
    "Etsy": "etsy",
    "European Union": "europeanunion",
    "Event Store": "eventstore",
    "Evernote": "evernote",
    "Every.org": "everydotorg",
    "Excalidraw": "excalidraw",
    "Exercism": "exercism",
    "Exordo": "exordo",
    "Exoscale": "exoscale",
    "Expedia": "expedia",
    "Expensify": "expensify",
    "Experts Exchange": "expertsexchange",
    "Expo": "expo",
    "Express": "express",
    "Express.com": "expressdotcom",
    "ExpressVPN": "expressvpn",
    "EyeEm": "eyeem",
};
